import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useOutsideClick from 'utils/useOutsideClick';
import common from 'constants/common';
import classnames from 'classnames';
import DropdownPlusIcon from '../icons/dropdownPlusIcon';

const ControlPanelButtonDropdown = ({
  label,
  buttons,
  icon: Icon,
  disabled = false,
}) => {
  const iconFillColor = disabled
    ? common.disabledIconColor
    : common.activeIconColor;
  const [isOpen, setIsOpen] = useState(true);
  const [isOverButton, setIsOverButton] = useState(false);
  const [isOverList, setIsOverList] = useState(false);

  useEffect(() => {
    if (isOpen && !isOverButton && !isOverList) {
      setIsOpen(false);
    } else if (!isOpen && (isOverButton || isOverList)) {
      setIsOpen(true);
    }
  }, [isOverButton, isOverList]);
  const dropdownRef = useRef();
  const wrapperRef = useRef();

  useOutsideClick(
    dropdownRef,
    () => setIsOpen(false),
    'ignore-onClickOutside-dropdown',
  );

  return (
    <div
      ref={wrapperRef}
      className="control-panel-dropdown__wrapper ignore-onClickOutside-dropdown"
    >
      <button
        className={classnames(
          'control-panel-button ignore-onClickOutside-dropdown',
          {
            disabled,
          },
        )}
        type="button"
        onMouseEnter={() => {
          setIsOverButton(true);
        }}
        onMouseLeave={() => {
          setIsOverButton(false);
        }}
        disabled={disabled}
      >
        <span className="control-panel-button__title">
          <span className="buttons ignore-onClickOutside-dropdown">
            {label}
          </span>
        </span>

        <Icon fill={iconFillColor} height="18" width="18" />
        {!disabled && (
          <DropdownPlusIcon
            className="dropdown-plus-icon"
            height="10"
            width="10"
          />
        )}
      </button>
      {isOpen ? (
        <div
          ref={dropdownRef}
          className="control-panel-dropdown"
          onMouseEnter={() => {
            setIsOverList(true);
          }}
          onMouseLeave={() => {
            setIsOverList(false);
          }}
        >
          <div className="control-panel-dropdown__inner">
            {buttons.map(
              (button, index) =>
                Boolean(button.render) && (
                  <button
                    className="control-panel-button border-0"
                    onClick={button.handleClick}
                    disabled={button.disabled}
                    type="button"
                    key={`${button.label}-${index}`}
                  >
                    <span className="control-panel-button__title">
                      <span className="buttons">{button.label}</span>
                      {button.bracketLabel && (
                        <span style={{ fontWeight: 'bold' }}>
                          {`(${button.bracketLabel})`}
                        </span>
                      )}
                    </span>
                    <button.icon height="18" width="18" />
                  </button>
                ),
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

ControlPanelButtonDropdown.propTypes = {
  icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  buttons: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ControlPanelButtonDropdown;
